// Module
var code = `<template>
  <mdc-dialog view-model.ref="dialog" scrim-click-action="">
    <mdc-dialog-title>Search In Available Categories</mdc-dialog-title>
    <mdc-dialog-content>
      <transaction-categories-lookup value.two-way="model.selectedCategory" placeholder="Search in category" type-id.bind="model.categoryTypeId">
      </transaction-categories-lookup>
    </mdc-dialog-content>
    <mdc-dialog-actions>
      <button mdc-button outlined data-mdc-dialog-action="cancel">Cancel</button>
      <button mdc-button raised data-mdc-dialog-action="save">Save</button>
    </mdc-dialog-actions>
  </mdc-dialog>
</template>
`;
// Exports
export default code;